import * as React from "react"
import { cn } from "../lib/utils"

interface EmptyStateProps {
  icon?: React.ReactNode
  title: string
  description?: string
  action?: React.ReactNode
  className?: string
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center rounded-lg border border-dashed border-border bg-card/50 px-6 py-12 text-center animate-fade-in",
        className
      )}
    >
      {icon && (
        <div className="mb-4 flex size-14 items-center justify-center rounded-full bg-accent text-primary [&_svg]:size-6">
          {icon}
        </div>
      )}
      <h3 className="text-foreground font-display text-card-title">{title}</h3>
      {description && (
        <p className="mt-2 max-w-sm text-sm text-text-tertiary">
          {description}
        </p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  )
}
